<template>
  <div class="home">
    <Dashboard msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Dashboard from '@/components/Dashboard.vue'

export default {
  name: 'HomeSite',
  components: {
    Dashboard
  }
}
</script>
